import React from 'react';

const waitChats = [
  { text: 'Kasa ho Hassan?', side: 'received', time: '8:02 PM', delay: 0.2 },
  { text: 'G theek 😊 Ap kasi ho?', side: 'sent', time: '8:03 PM', delay: 0.6 },
  { text: 'Main bhi theek 😊', side: 'received', time: '8:03 PM', delay: 1.0 },
  { text: 'Mara wait kar 4 saal tak', side: 'received', time: '8:05 PM', delay: 1.4 },
  { text: 'Okay... I am waiting for you 💕', side: 'sent', time: '8:06 PM', delay: 1.8 },
];

export default function WaitingSection() {
  return (
    <section id="waiting" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #0d0a14 0%, #0a0814 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse at 30% 50%, rgba(168,85,247,0.07) 0%, transparent 60%), radial-gradient(ellipse at 70% 30%, rgba(255,107,157,0.05) 0%, transparent 60%)',
        pointerEvents: 'none',
      }} />

      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 60, alignItems: 'center',
        }}>
          {/* Text */}
          <div>
            <div className="section-badge">
              <span>⏳</span> Chapter 7
            </div>
            <h2 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 800,
              fontSize: 'clamp(32px, 6vw, 56px)', lineHeight: 1.15, marginBottom: 8,
            }}>
              Hassan <span className="gradient-text">Waiting</span>
            </h2>
            <div className="section-divider" />
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 18px',
              background: 'rgba(168,85,247,0.08)',
              border: '1px solid rgba(168,85,247,0.2)',
              borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
              color: '#d8b4fe', marginBottom: 24,
            }}>
              ⏳ 27 October 2025
            </div>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 20,
            }}>
              On this night, Fiza said something that took courage — she asked Hassan to wait. 4 years. And without hesitation, without doubt, Hassan said: <span style={{ color: '#e2c8d8' }}>"Okay, I am waiting for you."</span> 💕
            </p>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 32,
            }}>
              That one promise said more than a thousand love letters. Real love doesn't rush — it waits, patiently, faithfully, with a full heart. 🌙✨
            </p>

            <div style={{
              background: 'linear-gradient(135deg, rgba(168,85,247,0.1), rgba(255,107,157,0.06))',
              border: '1px solid rgba(168,85,247,0.2)',
              borderRadius: 20, padding: '24px',
              marginBottom: 32,
            }}>
              <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
              <p style={{
                fontFamily: 'Nunito, sans-serif', fontSize: 17, lineHeight: 1.8,
                color: '#e2c8d8', fontStyle: 'italic', fontWeight: 600,
              }}>
                "Waiting for you is not a burden — it's a privilege. Because you're worth every single second." 💕
              </p>
              <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 13, color: '#9b7ba8', marginTop: 12 }}>
                — Hassan, 27 October 2025
              </div>
            </div>

            {/* Timer visual */}
            <div style={{
              display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12,
            }}>
              {[
                { val: '4', label: 'Years' },
                { val: '48', label: 'Months' },
                { val: '1460', label: 'Days' },
                { val: '∞', label: 'Love' },
              ].map(s => (
                <div key={s.label} style={{
                  background: 'rgba(168,85,247,0.08)',
                  border: '1px solid rgba(168,85,247,0.15)',
                  borderRadius: 14, padding: '16px 8px', textAlign: 'center',
                }}>
                  <div style={{
                    fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: 20,
                    background: 'linear-gradient(135deg, #a855f7, #ff6b9d)',
                    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}>{s.val}</div>
                  <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 11, color: '#9b7ba8', marginTop: 4 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Chat UI */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              width: '100%', maxWidth: 320,
              background: '#1a1228',
              border: '1px solid rgba(168,85,247,0.2)',
              borderRadius: 24, overflow: 'hidden',
              boxShadow: '0 30px 80px rgba(0,0,0,0.5), 0 0 40px rgba(168,85,247,0.1)',
            }}>
              {/* Header */}
              <div style={{
                padding: '16px 20px',
                background: 'linear-gradient(135deg, rgba(168,85,247,0.2), rgba(255,107,157,0.1))',
                borderBottom: '1px solid rgba(168,85,247,0.15)',
                display: 'flex', alignItems: 'center', gap: 12,
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
                }}>🦋</div>
                <div>
                  <div style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: 14, color: '#fff9fb' }}>
                    Fiza 💕
                  </div>
                  <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 11, color: '#a855f7' }}>
                    ● Online
                  </div>
                </div>
              </div>

              {/* Messages */}
              <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{
                  textAlign: 'center', padding: '6px 16px',
                  background: 'rgba(168,85,247,0.08)', borderRadius: 50, margin: '0 auto',
                  fontFamily: 'Nunito, sans-serif', fontSize: 11, color: '#9b7ba8',
                }}>27 October 2025 · 8:00 PM</div>

                {waitChats.map((c, i) => (
                  <div key={i} style={{
                    display: 'flex',
                    justifyContent: c.side === 'sent' ? 'flex-end' : 'flex-start',
                    animation: 'slideInBubble 0.5s ease forwards',
                    animationDelay: `${c.delay}s`,
                    opacity: 0,
                  }}>
                    <div>
                      <div style={{
                        maxWidth: 210, padding: '10px 14px',
                        borderRadius: c.side === 'sent' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                        background: c.side === 'sent' ?
                          'linear-gradient(135deg, #a855f7, #7c3aed)' :
                          '#2d1f4a',
                        color: c.side === 'sent' ? 'white' : '#e2c8d8',
                        fontFamily: 'Nunito, sans-serif', fontSize: 13.5, lineHeight: 1.5,
                        fontWeight: c.text.includes('wait') ? 600 : 400,
                      }}>
                        {c.text}
                      </div>
                      <div style={{
                        fontFamily: 'Nunito, sans-serif', fontSize: 10, color: '#9b7ba8',
                        marginTop: 3, textAlign: c.side === 'sent' ? 'right' : 'left',
                        paddingInline: 4,
                      }}>
                        {c.time} {c.side === 'sent' && '✓✓'}
                      </div>
                    </div>
                  </div>
                ))}

                {/* Reaction */}
                <div style={{
                  display: 'flex', justifyContent: 'center',
                  animation: 'bounceIn 0.6s ease forwards',
                  animationDelay: '2.4s', opacity: 0,
                }}>
                  <div style={{
                    padding: '8px 20px',
                    background: 'rgba(255,107,157,0.1)',
                    border: '1px solid rgba(255,107,157,0.2)',
                    borderRadius: 50,
                    fontFamily: 'Nunito, sans-serif', fontSize: 13,
                    color: '#ff6b9d',
                  }}>Fiza reacted 💕</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}